import XpManager from './XpManager';

export default XpManager;
export { XpManager };
